import { Autocomplete, TextField, TextFieldProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

type WizardAutocompleteFieldProps = {
  label: string;
  name: string;
  options: { id: string; label: string }[];
  helperText?: string;
  textFieldProps?: Omit<TextFieldProps, 'onChange' | 'value'>;
};

export const WizardAutocompleteField = ({
  label,
  name,
  helperText = '',
  options,
  textFieldProps = {},
}: WizardAutocompleteFieldProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const errorMessage = (errors[name]?.message as string) || helperText;
  const isError = !!errors[name];

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const selectedOption = options.find((opt) => opt.id === field.value) || null;

        return (
          <Autocomplete
            value={selectedOption}
            onChange={(_, newValue) => {
              field.onChange(newValue ? newValue.id : '');
            }}
            options={options}
            getOptionLabel={(option) => option.label}
            getOptionKey={(option) => option.id}
            isOptionEqualToValue={(option, value) => {
              if (!value) return false;
              return option.id === value.id;
            }}
            fullWidth
            renderInput={(params) => (
              <TextField
                {...params}
                {...textFieldProps}
                label={label}
                helperText={errorMessage}
                error={isError}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'new-password',
                }}
              />
            )}
          />
        );
      }}
    />
  );
};

